<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'Settings',
  mounted () {
    this.fetch()
  },
  computed: {
    ...mapState('settings', ['loaded', 'saving']),
    ...mapGetters('settings', ['addressVerificationEnabled']),
  },
  methods: {
    ...mapActions('settings', ['fetch', 'save']),
    toggleAddressVerification (enabled) {
      this.save({ key: 'ADDRESS_VERIFICATION_ENABLED', value: enabled ? '1' : '0' })
    },
  },
}
</script>

<template>
  <q-page class="settings-page">
    <div class="settings-card">
      <h5>Address Verification</h5>
      <p>
        Checks student addresses with Google as they are entered, on class saves and roster imports,
        and when an admin approves a class. Results are informational: they show next to each
        address, in the approval warning and in the Address Validation report, and never stop a
        class from being saved, approved, processed or paid for.
      </p>
      <p>
        Turning this off stops every request to Google's Address Validation API (which is billed per
        request). Results already recorded are kept and still appear in the report.
      </p>
      <q-toggle
        :value="addressVerificationEnabled"
        :disable="!loaded || saving || !$p(['ADMIN'])"
        label="Verify student addresses"
        @input="toggleAddressVerification"
      />
    </div>
  </q-page>
</template>

<style lang="stylus">
.settings-page
  padding 30px

  .settings-card
    max-width 640px
    padding 20px 24px
    background #fff
    border 1px solid #e0e0e0
    border-radius 4px

    h5
      margin 0 0 12px

    p
      margin 0 0 12px
      color #616161
</style>
